import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

// 10 minutes frontend cache for page layout query
const CACHE_TIME = 10 * 60 * 1000;

export const useCmsPageLayoutQuery = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['cms-page', { slug: slug! }],
    queryFn: fetchCmsPageLayout,
    enabled: !!slug,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
  });
};

const fetchCmsPageLayout: QueryFunction<any, [string, { slug: string }]> = async ({ queryKey }) => {
  const [, { slug }] = queryKey;
  const accessToken = getAccessToken();
  const { data } = await axios.get<any>(API.endpoints.pageLayout, {
    params: {
      slug,
    },
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
